export default "__VITE_ASSET__Bb68csba__"